<template>
  <SGPModalComponent
    tamanho="lg"
    titulo="Genciamento de subcampo"
    icon="mdi-file-tree"
    v-if="mostrarModal"
    @sgpModalFechar="fecharModalSubcampo"
    class="modal-subcampos"
  >
    <p>
      Os subcampos são campos do tipo select que possuem o valor das opções variaveis, que serão alterados de acordo com o valor 
      escolhido no campo pai. Que neste caso é o campo <strong>{{ campoAtual.ctrl_campo.label }}</strong>
    </p>

    <div v-for="(subcampo, index) in campoAtual.ctrl_formulario_subcampos" :key="subcampo" class="linha-subcampo">
      <SGPFormBotaoComponent
        fab
        text
        plain
        x-small
        class="mt-5 ml-2 remover-linha-subcampo"
        @click="deletarSubcampo(index)"
      >
        <SGPIconComponent>mdi-close</SGPIconComponent>
      </SGPFormBotaoComponent>

      <div class="d-flex align-items-center justify-content-center">
        <SGPFormInputComponent
          type="text"
          name="label"
          v-model="subcampo.label"
          placeholder="Rótulo do campo (Label)"
          placeholderText="Label"
          data-vv-as="Rótulo do campo (Label)"
          v-validate="'required|min:2'"
          :error="validationErrors.first('label')"
          class="mr-1"
          stylized
          solo
        />

        <SGPFormInputComponent
          type="text"
          name="label"
          v-model="subcampo.name"
          placeholder="Nome do campo (name)"
          placeholderText="Label"
          data-vv-as="Nome do campo (name)"
          v-validate="'required|min:2'"
          :error="validationErrors.first('label')"
          class="ml-1"
          stylized
          solo
        />
        
        <SGPFormCheckboxComponent
          label="Obrigatório"
          class="margin-top-24 margin-left-8"
          v-model="subcampo.obrigatorio"
        />
      </div>


      <div v-for="option in campoAtual.options" :key="option" class="subcampo-option-wrapper">
        <div class="d-flex align-items-center justify-content-space-between subcampo-option-header">
          <span>{{ option.label }}</span>
          <SGPFormBotaoComponent text fab class="ml-2" x-small @click="adicionarOpcaoSubcampo(option.value, subcampo)">
            <SGPIconComponent >mdi-plus</SGPIconComponent>
          </SGPFormBotaoComponent>
        </div>
        <div
          v-for="optionSubcampo in subcampo.options.filter(sub => sub.valor_comparacao == option.value)"
          :key="optionSubcampo"
          class="d-flex align-items-center justify-content-center"
        >
          <SGPFormInputComponent
            type="text"
            name="label"
            v-model="optionSubcampo.label"
            placeholder="Rótulo da opção (Label)"
            placeholderText="Label"
            data-vv-as="Rótulo da opção (Label)"
            class="mr-1"
            solo
          />

          <SGPFormInputComponent
            type="text"
            name="value"
            v-model="optionSubcampo.value"
            placeholder="Valor da opção"
            placeholderText="Label"
            data-vv-as="Valor da opção"
            class="ml-1"
            solo
          />
          <SGPFormBotaoComponent
            fab
            text
            plain
            small
            class="ml-2"
            @click="deletarSubcampoOption(optionSubcampo, subcampo)"
          >
            <SGPIconComponent>mdi-delete</SGPIconComponent>
          </SGPFormBotaoComponent>
        </div>
      </div>
    </div>

    <SGPFormBotaoComponent
      outlined
      class="mt-1 text-capitalize"
      @click="adicionarSubcampo"
      v-if="!campoAtual.ctrl_formulario_subcampos.length"
    >
      <SGPIconComponent>mdi-plus</SGPIconComponent>  Adicionar
    </SGPFormBotaoComponent>
  </SGPModalComponent>
</template>

<script>
export default {
  name: "SubcampoFormComponent",

  props: {
    campoAtual: {
      type: Object,
      required: true,
    },
    mostrarModal: {
      type: Boolean,
      required: true
    }
  },

  data () {
    return {
      subcampos: [],
      subcampo: {
        name: '',
        label: '',
        obrigatorio: false,
        options: []
      },

      optionSubampo: {
        label: '',
        value: '',
        valor_comparacao: ''
      }
    }
  },

  methods: {
    fecharModalSubcampo () {
      this.campoAtual.mostrar_subcampos = false
    },

    adicionarSubcampo() {
      this.campoAtual.ctrl_formulario_subcampos.push({
        ...this.subcampo,
        options: []
      })
    },

    deletarSubcampo(i) {
      this.campoAtual.ctrl_formulario_subcampos.splice(i, 1)
    },

    adicionarOpcaoSubcampo (valor, subcampo) {
      subcampo.options.push({
        label: '',
        value: '',
        valor_comparacao: valor
      })
    },

    deletarSubcampoOption(optionSubcampo, subcampo) {
      subcampo.options = [...subcampo.options.filter(opt => opt !== optionSubcampo)]
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/_variables.scss';

.linha-subcampo {
  padding: 15px !important;
  background: $color-neutral-light;
  border: solid 1px $color-neutral-medium;
  position: relative;
  margin-bottom: 15px;
  border-radius: 8px;
  transition: all 0.5s;

  &:nth-child(odd) {
    background: $color-neutral-medium;
    border: solid 1px $color-neutral-medium;
  }

  &:hover {
    border: solid 1px $color-neutral-dark;
    background: $color-neutral-medium;
  }

  .remover-linha-subcampo {
    position: absolute;
    z-index: 555;
    top: -18px;
    right: 4px;
  }

  .subcampo-option-wrapper {
    border-bottom: solid 1px #cecece;
    padding: 5px 0;

    &:last-child {
      border: none;
    }

    .subcampo-option-header {
      padding: 10px 5px;
    }
  }
}

</style>